import { Box, Flex, Text } from '@chakra-ui/react'
import { ProductItem } from 'types/graphql'

import { ItListItemAnalyticsProps } from 'src/lib/hooks/analytics/useAnalytics'
import { BrandColor } from 'src/types'

import CardWrapper from '../../CardWrapper/CardWrapper'
import Thumbnail from '../../Thumbnail/Thumbnail'
import Title from '../../Title/Title'
import VoiceTip from '../../VoiceTip/VoiceTip'

import ProductFooter from './ProductFooter/ProductFooter'
import useProductCard from './useProductCard'

const HEIGHT_WITH_BOTH_URLS = 250
const HEIGHT_WITH_ONE_URL = 190

export type ProductCardProps = {
  profilePictureUrl: string
  brandColor: BrandColor
  url?: string
  voiceTipUrl: string
  hasVoiceTip: boolean
  title?: string
  trackingData: ItListItemAnalyticsProps
  productItem: ProductItem
  itemId: number
}

const ProductCard = ({
  brandColor,
  profilePictureUrl,
  url,
  productItem,
  title,
  voiceTipUrl,
  hasVoiceTip,
  trackingData,
  itemId,
}: ProductCardProps) => {
  const { promoCodeInfo } = useProductCard(productItem, url)

  return (
    <CardWrapper
      itemId={itemId}
      brandColor={brandColor}
      offScreenRender={
        <Box
          w="100%"
          bg="dust"
          h={
            url && productItem.amazonUrl
              ? HEIGHT_WITH_BOTH_URLS
              : HEIGHT_WITH_ONE_URL
          }
        />
      }
    >
      <>
        <Flex gap={4} justifyContent="space-between" alignItems="center" p={4}>
          <Flex gap={2} direction="column" alignItems="flex-start">
            <Title title={title} defaultTitle="Untitled Product..." />
            {promoCodeInfo?.expirationLabel && (
              <Text className="body-extra-small-emphasis" color="stone">
                {promoCodeInfo.expirationLabel}
              </Text>
            )}
            <VoiceTip
              mediaUrl={voiceTipUrl}
              hasVoiceTip={hasVoiceTip}
              title={title}
              pictureUrl={profilePictureUrl}
              brandColor={brandColor}
              trackingData={trackingData}
            />
          </Flex>
          <Thumbnail
            coverUrl={productItem.coverUrl}
            type="product"
            brandColor={brandColor}
          />
        </Flex>
        <ProductFooter
          promoCodeInfo={promoCodeInfo}
          url={url}
          brandColor={brandColor}
          profilePictureUrl={profilePictureUrl}
          product={productItem}
          trackingData={trackingData}
        />
      </>
    </CardWrapper>
  )
}

export default ProductCard
